import { BaseApi } from "../BaseApi";
import { TOKEN_TYPE } from "../../utils/Constant";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const getTokenUrl = "api/v1/websalud/primeraars/auth/login";

const logOutUrl = "api/v1/websalud/primeraars/auth/logout";

const newSessionUrl = "api/v1/websalud/primeraars/sesion/inicio";

const getUserInfoUrl = "api/v1/websalud/primeraars/prestadores/yo";

const getUsersMeUrl = "api/v1/websalud/primeraars/auth/users/me";

const getUsersUrl = "api/v1/websalud/primeraars/auth/users";

const getResourceUrl = "api/v1/websalud/primeraars/auth/resource";

const assignRoleUrl = "api/v1/websalud/primeraars/auth/assign-role";

const deleteRoleUrl = "api/v1/websalud/primeraars/auth/delete-role";

const authStandVirtualUrl =
  "api/v1/websalud/primeraars/auth/standvirtual/login";

const configuracionPaperFreeUrl = (request) =>
  `api/v1/websalud/primeraars/prestadores/${request.codigoPss}/configuracion`;

const getToken = (request) =>
  BaseApi.post(getTokenUrl, request).then((response) => response.data);

const newSession = (request) =>
  
  InterceptToken(
    BaseApi.post,
    newSessionUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const newSessionWithNoHeader = (request) =>
  InterceptToken(BaseApi.post, newSessionUrl, request).then(
    (response) => response.data
  );

const getUserInfo = (request) =>
  InterceptToken(
    BaseApi.get,
    getUserInfoUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const getUsersMe = (request) =>
  InterceptToken(
    BaseApi.get,
    getUsersMeUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const getUsers = (request) =>
  InterceptToken(
    BaseApi.get,
    `${getUsersUrl}?provider=ad&searchTerm=${request?.searchTerm || ""}`,
    null,
    request.requestHeaders
  ).then((response) => response.data);

const getResource = (request) =>
  InterceptToken(
    BaseApi.get,
    getResourceUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const assignRole = (request) =>
  BaseApi.post(assignRoleUrl, request.requestData, {
    headers: request.requestHeaders,
  }).then((response) => response.data);

const deleteRole = (request) =>
  BaseApi.post(deleteRoleUrl, request.requestData, {
    headers: request.requestHeaders,
  }).then((response) => response.data);

const getConfiguracionPaperFree = (request) =>
  InterceptToken(
    BaseApi.get,
    configuracionPaperFreeUrl(request?.requestData),
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const authStandVirtual = (request) =>
  BaseApi.post(authStandVirtualUrl, request).then((response) => response.data);

const logOut = (request) =>
  BaseApi.post(logOutUrl, request).then((response) => response.data);

const notifyLogOutAllTabs = () => {
  localStorage.setItem("cerrar_sesion", Date.now().toString());

  setTimeout(() => {
    localStorage.removeItem("cerrar_sesion");
  }, 1000);
};

const redirectToLogin = () => {
  window.location.replace(process.env.REACT_APP_REDIRECT_URL);
};

const handleRequestAuth = (request, accessToken) => {
  return {
    requestData: request,
    requestHeaders: {
      Authorization: `${TOKEN_TYPE.BEARER} ${accessToken}`,
    },
  };
};

const handleRequestAuthPin = (request, accessToken = null, pin = null) => {
  return {
    requestData: request,
    requestHeaders: {
      Authorization: `${TOKEN_TYPE.BEARER} ${accessToken}`,
      Pin: btoa(pin),
    },
  };
};

const handleRequestSession = (request, numeroSesion) => {
  return {
    requestData: request,
    requestHeaders: {
      "x-numero-sesion": numeroSesion,
      "x-tipo-servicio": request.tipoServicio
    },
  };
};

const exportedObject = {
  getToken,
  newSession,
  newSessionWithNoHeader,
  getUserInfo,
  getUsersMe,
  getUsers,
  getResource,
  assignRole,
  deleteRole,
  logOut,
  notifyLogOutAllTabs,
  redirectToLogin,
  getConfiguracionPaperFree,
  handleRequestAuth,
  handleRequestAuthPin,
  handleRequestSession,
  authStandVirtual,
};

export default exportedObject;
